import axios from "axios";
import { useState } from "react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function useSubmit(endpoint) {
  const [loading, setLoading] = useState(false);
  const submit = async (data, onSuccess) => {
    setLoading(true);
    try {
      const res = await api.post(endpoint, data);
      toast.success(res.data.message || "Received — thank you!");
      onSuccess?.(res.data);
      return res.data;
    } catch (e) {
      toast.error("Something went wrong. Please try again.");
      return null;
    } finally {
      setLoading(false);
    }
  };
  return { loading, submit };
}
